import { isNil } from 'lodash-es';
import { RefObject, useLayoutEffect, useState } from 'react';

/**
 * @description 获取ClientRect
 * @param ref 引用对象 RefObject<HTMLElement>
 * @returns
 */
export const useClientRect = (ref: RefObject<HTMLElement>, deps: any[] = []): DOMRect => {
	const [clientRect, setClientRect] = useState<any>({});

	useLayoutEffect(() => {
		if (ref.current) {
			setClientRect(ref.current?.getBoundingClientRect());
		}
	}, [ref.current, ...deps]);

	return clientRect;
};

interface PlaceRect {
	left: number;
	top: number;
}

const OFFSET = 4;

/**
 * 获取tip内容的位置
 * @param triggerRect 触发元素的DOMRect信息
 * @param tipContentRect tip内容的DOMRect信息
 * @param placement 位置
 * @returns PlaceRect 位置
 */
export const getPosition = (
	triggerRect: DOMRect | undefined,
	tipContentRect: DOMRect | undefined,
	placement: 'top' | 'right' = 'top',
): PlaceRect => {
	const placeRect = { left: 0, top: 0 };

	if (isNil(triggerRect?.left) || isNil(tipContentRect?.left)) {
		return placeRect;
	}

	const gaps = { top: 4, right: 12 };
	const { clientWidth } = document.documentElement;

	if (placement === 'top') {
		placeRect.left = triggerRect.left + (triggerRect.width - tipContentRect.width) / 2;

		if (placeRect.left < 0) {
			placeRect.left = OFFSET;
		}

		const leftDiff = placeRect.left + tipContentRect.width - (clientWidth - OFFSET);
		if (leftDiff > 0) {
			placeRect.left -= leftDiff;
		}

		placeRect.top = Math.max(triggerRect.top - tipContentRect.height - gaps.top, OFFSET);
	} else if (placement === 'right') {
		placeRect.left = triggerRect.left + triggerRect.width + gaps.right;
		placeRect.top = triggerRect.top + (triggerRect.height - tipContentRect.height) / 2;
	}
	return placeRect;
};
